// extracted by mini-css-extract-plugin
export default {"desktopHeader":"style_desktopHeader__+jfL+"};